import React from 'react'
// ##
import TypesTable from '../../modules/Type/components/TypesTable'

export default function TypePage() {
  return <TypesTable />
}
